import isServer from './isServer';

export default function getCookie(): string {
  if (isServer()) return '';
  return document.cookie;
}
